<button class="kebabMenu" [disabled]="disabled" mat-button [matMenuTriggerFor]="menu" (menuOpened)="menuOpened()">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu" class="matMenu">
  <ng-container *ngFor="let k of (filteredMenuOptions || kebabMenuOptions)">
    <button class="menu-button" [disabled]="k.disabled" matTooltip="{{k.tooltip}}" mat-menu-item
      (click)="onclickKebab(k.key, element)">{{k.value}}</button>
  </ng-container>
</mat-menu>